<script>
	// TODO: add support for file inputs
	import InputCheck from '$lib/Components/Input/InputCheck/InputCheck.svelte';
	import InputRadio from '$lib/Components/Input/InputRadio/InputRadio.svelte';
	import InputSearch from '$lib/Components/Input/InputSearch/InputSearch.svelte';
	import InputSelect from '$lib/Components/Input/InputSelect/InputSelect.svelte';
	import InputTel from '$lib/Components/Input/InputTel/InputTel.svelte';
	import InputText from '$lib/Components/Input/InputText/InputText.svelte';
	import InputTextArea from '$lib/Components/Input/InputTextArea/InputTextArea.svelte';
	import { formFieldProxy } from 'sveltekit-superforms';

	let {
		form = null,
		name,
		label = null,
		element = $bindable(),
		loading = $bindable(),
		required = null,
		type = 'text',
		placeholder = null,
		autocomplete = null,
		disabled = null,
		tabindex = null,
		list = null,
		phoneCountry = 'US',
		phoneNational = null,
		options = [],
		class: className = '',
		valueField = 'value',
		labelField = 'label',
		unitLabel = null,
		onTainted = null,
		onchange = null,
		...props
	} = $props();

	let { form: innerForm } = form;
	const field = formFieldProxy(form, name);
	const { value, errors, constraints, tainted } = field;

	$effect(() => {
		if ($tainted && onTainted) {
			onTainted($tainted, field);
		}
	});
</script>

{#if type == 'radio'}
	<InputRadio
		{options}
		{label}
		{name}
		{tabindex}
		{disabled}
		{required}
		{...$constraints}
		{onchange}
		type="radio"
		bind:group={$innerForm[name]}
		bind:element
		{...props}
		class={className}
		error={$errors}
	/>
{:else if type == 'email'}
	<InputText
		{label}
		{name}
		{autocomplete}
		{tabindex}
		{disabled}
		type="email"
		{placeholder}
		bind:value={$value}
		bind:element
		{...$constraints}
		{onchange}
		{required}
		error={$errors}
		class={className}
		{...props}
	/>
{:else if type == 'tel'}
	<InputTel
		bind:value={$value}
		bind:element
		{label}
		{name}
		{disabled}
		{...$constraints}
		{required}
		{phoneCountry}
		{phoneNational}
		{onchange}
		error={$errors}
		class={className}
		{...props}
	></InputTel>
{:else if type == 'checkbox'}
	<InputCheck
		bind:element
		bind:value={$value}
		{required}
		{label}
		{name}
		{autocomplete}
		{tabindex}
		{disabled}
		{onchange}
		error={$errors}
		{...$constraints}
		{...props}
		class={className}
	/>
{:else if type == 'search'}
	<InputSearch
		bind:value={$value}
		bind:element
		type="search"
		{name}
		{loading}
		{label}
		{autocomplete}
		{tabindex}
		{disabled}
		{required}
		{onchange}
		error={$errors}
		{...$constraints}
		{...props}
		class={className}
	/>
{:else if type == 'textarea'}
	<InputTextArea
		bind:value={$value}
		bind:element
		{label}
		{name}
		{autocomplete}
		{placeholder}
		{tabindex}
		{disabled}
		{required}
		{onchange}
		error={$errors}
		{...$constraints}
		{...props}
		class={className}
	/>
{:else if type == 'select'}
	<InputSelect
		bind:value={$value}
		bind:element
		{valueField}
		{labelField}
		{label}
		{name}
		{placeholder}
		{required}
		{disabled}
		{autocomplete}
		{tabindex}
		{onchange}
		error={$errors}
		{options}
		{...props}
		class={className}
	/>
{:else}
	<InputText
		bind:value={$value}
		bind:element
		{name}
		{label}
		{autocomplete}
		{tabindex}
		{required}
		{disabled}
		{onchange}
		{placeholder}
		error={$errors}
		{list}
		{...$constraints}
		{...props}
		class={className}
		{type}
		{unitLabel}
	/>
{/if}
